import { useState,useRef, useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import LoadingOverlay from "react-loading-overlay-ts";
import _ from "lodash";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import PageLayout from "../PageLayout";
import DesignHeader from "../AWMJobs/DesignJobs/DesignHeader";
import FooterButtons from "../AWMJobs/DesignJobs/FooterButtons";
import WaveHeader from "./WaveHeader";
import Waves from "./Waves";
import UnAuthorizedComponent from "../UnAuthorized/UnAuthorizedComponent";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../common/NavigationPrompt";
import { getWaveDetails } from "../../store/actions/WaveActions";
import moment from "moment-timezone";
import { submitWave } from "../../apis/waveApi";
import { Toast } from "primereact/toast";
import {
  sortedDataAsPerJobID,
  checkFormValidityWaves,
  redirectToProjectPlanOrTaskPage,
  detectDateFormat,
} from "../../utils";
import "./index.scss"

let waveObj = {
  Wave_Color_Code_BG: "",
  Wave_Color_Code_TEXT: "",
  Wave_ID: "",
  Est_AW_Printer_Date: "",
  T_POA_Owner: null,
  Estimated_Start_Date: "",
  Qty_Of_FA: "",
  Wave_Name: ""
};

function Wave() {
  const navigate = useNavigate();
  const toast = useRef();
  let { TaskID, page1, page2, pageType, ProjectID } = useParams();
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User.userInformation;

  const [waves, setWaves] = useState([]);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [checked, setChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [accessType, setAccessType] = useState("Write");
  const [accessSecurityMatrix, setUserAccess] = useState(true);
  const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(true);
  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [deletedItems, setDeletedItems] = useState([]);
  const [InitialWaves, setInitialWaves] = useState([]);
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const [isWaveNameError, setIsWaveNameError] = useState(false);
  
  const {
    userDetails: { AccessGroup, UserGroup },
  } = useSelector((state) => state?.UserDetailsReducer);

  const dispatch = useDispatch();
  
  let { WaveDetailsData,loading } = useSelector((state) => state.WaveReducer);

  WaveDetailsData = (ProjectID !== undefined && ProjectID !== "") ? WaveDetailsData : null;

  const headerName = "Wave Specification";
  const shortName = "Wave Specification";

  let checkProjectIsDraft = WaveDetailsData?.ProjectState === "Draft";
  const Count_Of_PMPs = WaveDetailsData?.Count_Of_PMPs || 0;
  let waveDesignDisabled = ( !accessSecurityMatrix && WaveDetailsData?.ProjectState  !== "Draft" );

   useEffect(() => { 
    if (waves.length === 0) setEnableSubmit(true);
    else {
      checkFormValidityWaves(waves, Count_Of_PMPs,setEnableSubmit);
    }
    const isObjectEqual = JSON.stringify(InitialWaves) === JSON.stringify(waves);
    if (!isObjectEqual) { 
      setPageEdited(true);
    } else {
      setPageEdited(false);
      setEnableSubmit(true);
    }
  }, [waves]);

  // 3109 security matrix
  const userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      ProjectID: ProjectID,
      UserGroup: UserGroup,
    },
  };

  useEffect(() => {
    if( userInformation?.userid && UserGroup?.length && ProjectID ){
      setLoader(false);
      dispatch(getWaveDetails(ProjectID, userAccessPayLoad));
    }
  }, [dispatch, ProjectID, userInformation?.userid, UserGroup?.length]);

  useEffect(() => {
    if (WaveDetailsData?.WaveDetails?.length > 0) {
      let allWaves = WaveDetailsData?.WaveDetails || [];
      setInitialWaves(allWaves);
      setWaves(allWaves);
      setProjectName(WaveDetailsData?.ProjectName);
    } else if (WaveDetailsData && waves.length === 0) {
      setWaves([]);
      addNewWave(true);
      setProjectName(WaveDetailsData?.ProjectName);
    }
  }, [WaveDetailsData]);

  useEffect(() => {
    if (pageEdited) {
      markDirty();
    } else {
      markClean();
    }
  }, [pageEdited]);
  
  useEffect(() => {
    markClean();
    setPageEdited(false);
  }, []);

  const handleCancel = () => {
    navigate(`/capacityManagement/planning`);
  };

 const handleCancelClick = () => {
    if (pageEdited) {
      setShowDialog(true);
    } else {
      handleCancel();
    }
  };

  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
  };
  // it will navigate to previously saved url navigate(pendingNavigation);
  // by doing setShowDialog(false) and setPendingNavigation("");
  const confirmNavigation = () => {
    markClean();
    handleCancel();
    setPageEdited(false);
    setShowDialog(false);
  };

  const handleProjectNameClick = () => {
    if (pageEdited) {
      setShowDialog(true);
    } else {
      handleProjectName();
    }
  };

  const handleProjectName = () => {
    if (page2 && page2.toLowerCase() === "projectplan") {
      return navigate(`/${page1}/${page2}/${ProjectID}`);
    } 
    else if (page2 && page2.toLowerCase() === "planning") {
      return navigate(`/allProjects/projectPlan/${ProjectID}`);
    }
    else if (pageType) {
      if (pageType.toLowerCase() === "mytasks") {
        navigate(`/myProjects/projectPlan/${ProjectID}`);
      } else if (pageType.toLowerCase() === "alltasks") {
        navigate(`/allProjects/projectPlan/${ProjectID}`);
      }
    }
  };

  const addNewWave = (isNew = false) => {  
    const wave_index = waves?.length === 0 ? 1 : waves?.length + 1;
    waveObj = { ...waveObj, Wave_Name: `Wave ${wave_index}` };
    if (isNew) {
      setWaves([waveObj]);
      setInitialWaves([waveObj]);
    } else {
      const clonedTasks = _.cloneDeep(waves);
      clonedTasks.push(waveObj);
      setWaves(clonedTasks);
    }
  };

  const formatPayloadDate = (date) => {
    if (date) {
      const detectedFormat = detectDateFormat(date);
      const formattedDate = detectedFormat
        ? moment(date, detectedFormat).format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]")
        : moment(date, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)").format("YYYY-MM-DD[T]HH:mm:ss.SSS[Z]");
      
      return formattedDate;
    } else {
      return date;
    }
  };

  const getWaveCollectFormData = (data) => {
    return data.map((wave) => {
      if ("Qty_Of_FA" in wave) {
        return {
            Est_AW_Printer_Date: formatPayloadDate(wave?.Est_AW_Printer_Date),
            T_POA_Owner: wave?.T_POA_Owner?.Person || wave?.T_POA_Owner,
            Estimated_Start_Date: formatPayloadDate(wave?.Estimated_Start_Date),
            Qty_Of_FA: wave?.Qty_Of_FA,
            Wave_Name: wave?.Wave_Name,
        };
      }});
  };

  const collectFormData = (data = []) => {
    const WaveCollectFormData = getWaveCollectFormData(data)
      
    const formData = {
      AWMProjectID: ProjectID,
      updateOperator : userInformation?.userid,
      Count_Of_PMPs: Count_Of_PMPs,
      WaveDetails: [...WaveCollectFormData],
    };
    return formData;
  }

  const handleDelete = (index) => {
    const updatedTasks = _.cloneDeep(waves); // Create a copy of the original array
    // Remove the deleted item from the designIntent array
    updatedTasks.splice(index, 1);

    setWaves(updatedTasks);
  };

  const handleDeleteJob = async (Design_Job_ID) => {
      setLoader(true);
      let updatedData = {};
      let updatedDataList = [];
      // Combine the designIntent and deletedItems arrays for submission
      const combinedData = [...waves, ...deletedItems];
      let submitOnlySelectedData = combinedData.filter(
        (task) => Design_Job_ID === task?.Design_Job_ID
      );
    };

  const onSubmit = async () => {
    setLoader(true);

    if (WaveDetailsData?.Count_Of_PMPs) {
      let FormData = collectFormData(waves); 
      const res_submitCustomFullkit = await submitWave(
        FormData,
      );
      if (res_submitCustomFullkit.status === 200) {
        setLoader(false);
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Waves created successfully",
          life: 3000,
        });
        dispatch(getWaveDetails(ProjectID, userAccessPayLoad));
        setTimeout(() => navigate(`/capacityManagement/planning`), 4000);
      } else {
        setLoader(false);
        toast.current.show({
          severity: "warn",
          summary: "Error",
          detail: "Error in wave specification",
          life: 3000,
        });
      }
    } 
  };
  
  return (
    <PageLayout>
      <Toast ref={toast} />
      {accessSecurityMatrix ? (
        <LoadingOverlay active={loader || loading} spinner text="">
          <DesignHeader
            setAddNewDesign={addNewWave}
            headerName={headerName}
            label={shortName}
            lastLabel={"Wave Specifications"}
            checked={checked}
            pageEdited={pageEdited}
            setPageEdited={setPageEdited}
            setChecked={setChecked}
            checkReadWriteAccess={checkReadWriteAccess}
            showCommonCheckbox={"No"}
            checkTaskISComplete={!checkProjectIsDraft}
            disabled={waveDesignDisabled}
          />
          <WaveHeader
            projectName={projectName}
            handleProjectNameClick={handleProjectNameClick}
            Count_Of_PMPs={Count_Of_PMPs}
          />
          <div className="fullkit-parentJob-details">
            {waves &&
              waves?.length > 0 &&
              waves?.map((waveDetails, index) => (
                <Waves
                  key={`waveno-${index}`}
                  index={index}
                  waveDetails={waveDetails}
                  checkReadWriteAccess={checkReadWriteAccess}
                  waves={waves}
                  setWaves={setWaves}
                  assigneeListOptions={WaveDetailsData?.OwnersList}
                  setPageEdited={setPageEdited}
                  handleDelete={handleDelete}
                  handleDeleteJob={handleDeleteJob}
                  Project_Status={WaveDetailsData?.ProjectState}
                  Wave_ID={waveDetails?.Wave_ID}
                  waveDesignDisabled={waveDesignDisabled}
                  setIsWaveNameError={setIsWaveNameError}
                />
              ))}
          </div>
          <FooterButtons
            accessType={accessType}
            handleCancel={handleCancelClick}
            onSubmit={onSubmit}
            formValid={enableSubmit || isWaveNameError}
            bottomFixed={true}
            hideSaveButton={true}
          />
        </LoadingOverlay>
      ) : (
        AccessGroup && AccessGroup.length && <UnAuthorizedComponent nowrapper={true} />
      )}
      {/* UnsavedChangesDialog popup */}
      <UnsavedChangesDialog
        visible={showDialog}
        onCancel={cancelNavigation}
        onConfirm={confirmNavigation}
      />
    </PageLayout>
  );
}

export default Wave;
